// The three properties every outstanding suggestions modal event carries.

import { OutstandingSuggestion } from './outstandingSuggestions';
import { sendEvent } from 'util/pendoTrack';

type ModalEventContext = Record<string, string | number | null | undefined>;

export const BULK_REJECT_TRIGGER = 'bulk_reject';

// Each step of the funnel, named as its event's suffix on both surfaces.
export type OutstandingSuggestionsModalStep =
  | 'viewed'
  | 'dismissed'
  | 'reject_all'
  | 'review';

export type OutstandingSuggestionsModalEvents = Record<
  OutstandingSuggestionsModalStep,
  string
>;

// What a surface hands its caller so the funnel can be reported as it happens.
export type OutstandingSuggestionsTracking<
  Field extends OutstandingSuggestion = OutstandingSuggestion
> = {
  modalViewed: (outstanding: Field[]) => void;
  modalDismissed: (outstanding: Field[]) => void;
  modalRejectAll: (outstanding: Field[]) => void;
  modalReview: (outstanding: Field[]) => void;
};

export const sendOutstandingSuggestionsModalEvent = (
  eventName: string,
  outstanding: OutstandingSuggestion[],
  context: ModalEventContext
): void =>
  sendEvent(eventName, {
    ...context,
    outstanding_count: outstanding.length,
    // Uncapped, unlike the modal's list: which fields get left is the measure.
    fields: outstanding
      .map(({ autoDocExtField }) => autoDocExtField)
      .join(', '),
    path: window.location.pathname,
  });
